import React from 'react';
import { StyleSheet } from 'react-native';
import PropTypes from 'prop-types';

import { Theme } from '@constants';

import { TWCText } from '../primitives/TWCText/TWCText';

// Provides a way to show text centered at a specfied view (x, y).
export const MapPositionedText = ({ x, y, variant, children }) => {
  // Web platforms can just use a % translation and be done with it.
  const baseStyle = styles.plottedTextWeb;
  const transform = { transform: 'translate(-50%, -50%)' };

  return (
    <TWCText
      noTestID
      style={[
        {
          left: x,
          top: y,
        },
        baseStyle,
        transform,
      ]}
      variant={variant}
    >
      {children}
    </TWCText>
  );
};

MapPositionedText.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  variant: PropTypes.string.isRequired,
};

// Stylesheets

const styles = StyleSheet.create({
  plottedTextWeb: {
    position: 'absolute',
    textShadowColor: Theme.black,
    textShadowOffset: { width: 1, height: 1 },
    textShadowRadius: 2,
  },
});
